import { TransactionStatusDateState } from '../state/transaction-status-date.state';
import {
    TransactionAction,
    TransactionsActions,
} from '../actions/transactions.actions';
import { TransactionStatusDate } from '../models/transaction-status-date.model';
import { WithdrawAction } from '../models/action.model';

export const initialTransactionStatusDatesState: TransactionStatusDateState = {
    null: [
        {
            date: new Date(),
            executionId: '',
        },
    ],
};

export function transactionStatusDateReducer(
    state = initialTransactionStatusDatesState,
    action: TransactionAction
) {
    switch (action.type) {
        case TransactionsActions.SuccessGetTransaction:
            const newState = { ...state };

            newState[action.transactionId] = [
                ...getTransactionStatusDatesFromActions(action.actions),
            ];

            return newState;
        default:
            return state;
    }
}

export function getTransactionStatusDatesFromActions(
    actions: WithdrawAction[]
): TransactionStatusDate[] {
    const transactionStatusDates: TransactionStatusDate[] = actions.map(
        (a) => new TransactionStatusDate(a.dateTime, a.metadata.executionId)
    );

    return transactionStatusDates;
}
